import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { NotificationContentProps } from "../../types";

const ProjectIdeaCommented = ({
  events = [],
  ownerIdea,
  ownerChallenge,
}: NotificationContentProps) => {
  return (
    <Trans
      i18nKey="notifications.projectIdeaCommented"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        challenge: ownerChallenge?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
};

export default ProjectIdeaCommented;
